import React from 'react';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import Svg, { Circle } from 'react-native-svg';

import type { LoadMainVariantProps } from '../types';
import { useLoaderSpin } from '../loadMainMotion';

export function RingLoader({ size, colors, duration_ms }: LoadMainVariantProps) {
  const stroke_width = Math.max(2.5, size * 0.07);
  const radius = (size - stroke_width) / 2;
  const center = size / 2;
  const circumference = 2 * Math.PI * radius;
  const gap = circumference * 0.22;
  const rotation = useLoaderSpin(duration_ms);
  const counter_rotation = useLoaderSpin(Math.round(duration_ms * 1.65));

  const outer_style = useAnimatedStyle(() => ({
    transform: [{ rotate: `${rotation.value}deg` }],
  }));

  const inner_style = useAnimatedStyle(() => ({
    transform: [{ rotate: `${-counter_rotation.value * 0.55}deg` }],
  }));

  return (
    <Animated.View style={{ width: size, height: size }}>
      <Animated.View style={[{ width: size, height: size, position: 'absolute' }, outer_style]}>
        <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <Circle
            cx={center}
            cy={center}
            r={radius}
            stroke={colors.glow}
            strokeWidth={stroke_width}
            fill="none"
          />
          <Circle
            cx={center}
            cy={center}
            r={radius}
            stroke={colors.primary}
            strokeWidth={stroke_width}
            fill="none"
            strokeDasharray={`${circumference - gap} ${gap}`}
            strokeLinecap="round"
          />
        </Svg>
      </Animated.View>
      <Animated.View style={[{ width: size, height: size, position: 'absolute' }, inner_style]}>
        <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <Circle
            cx={center}
            cy={center}
            r={radius * 0.62}
            stroke={colors.highlight}
            strokeWidth={Math.max(2, stroke_width * 0.72)}
            fill="none"
            strokeDasharray={`${(circumference * 0.62) * 0.34} ${circumference}`}
            strokeLinecap="round"
          />
        </Svg>
      </Animated.View>
    </Animated.View>
  );
}
